/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import RequestedPreviousClaimHeader from './components/RequestedPreviousClaimHeader';
import { setSearchErrorMessage } from './store/action';

const RequestPreviousClaim = () => {
  const dispatch = useDispatch();
  // const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const setErrorMessages = (err) => dispatch(setSearchErrorMessage(err));
  const searchScrErr = useSelector(
    (state) => state?.sharedState?.requestedPreviousClaim.searchScrErr
  );
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/requestedPreviousClaim') {
          if (searchScrErr?.length > 0) {
            item.isFormError = true;
            setLoading(false);
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [searchScrErr]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}

      <CustomSeparator
        parent1={'System'}
        parent2={'Technical Window'}
        parent3={'Online Fixes'}
        parent4={'Add Previous Claim to Omitted Claim Table'}
      />
      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      <DisplayErrorMessages errorMessages={searchScrErr} />

      <RequestedPreviousClaimHeader
        setErrorMessages={setErrorMessages}
        setLoading={setLoading}
        setSuccessMessages={setSuccessMessages}
      />
    </div>
  );
};

export default RequestPreviousClaim;
